/*
 * sidebar-options-item
 */
import { cn } from "@psychology/react-ui"
import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from "@psychology/react-ui"
import { Ellipsis } from "lucide-react"
import type { ReactNode } from "react"
import { useIsInSheetSidebar } from "./sidebar.context"
import { useSidebarToggle } from "./use-sidebar-toggle"

interface SidebarOptionsItemProps {
	groupLabel: string
	children?: ReactNode
	className?: string
}

export function SidebarOptionsItem({
	groupLabel,
	children,
	className,
}: SidebarOptionsItemProps) {
	const sidebar = useSidebarToggle()
	const isInSheet = useIsInSheetSidebar()

	const finalSidebarIsOpen = isInSheet || sidebar.isOpen

	return (
		<li className={cn("w-full", groupLabel ? "pt-1" : "", className)}>
			{finalSidebarIsOpen && groupLabel ? (
				<p
					className={
						"text-paper-foreground max-w-sidebar-open truncate pb-1 pl-4 text-sm font-medium"
					}
				>
					{groupLabel}
				</p>
			) : !finalSidebarIsOpen && groupLabel ? (
				<TooltipProvider>
					<Tooltip delayDuration={100}>
						<TooltipTrigger className={"w-full"}>
							<div className={"flex h-4 w-full items-center justify-center"}>
								<Ellipsis className={"text-paper-foreground size-5"} />
							</div>
						</TooltipTrigger>
						<TooltipContent side={"right"}>
							<p>{groupLabel}</p>
						</TooltipContent>
					</Tooltip>
				</TooltipProvider>
			) : (
				<p className={"pb-2"}></p>
			)}
			{children}
		</li>
	)
}
